import {mutations} from './mutations';
import {getters} from './getters';
import {actions} from './actions';
import {AdminState} from './state';
import {IAddress} from "@/interfaces/address";
import {IRoleSettings} from "@/interfaces/role";

const defaultState: AdminState = {
  users: [],
  forms: [],
  groups: [],
  roles: [],
  external_data_list: [],
  search_engines: [],
  role_settings: {} as IRoleSettings,
  external_users: [],
  form_categories: [],
  institutions: [],
  address: {} as IAddress,
};

export const adminModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
